import React, { PureComponent } from "react";
import ArrowIcon from '../../containers/assets/dropdown-arrow.svg';
import {
  DropDownHeader,
  DropDownListContainer,
  DropDownList,
  DropDownContainer,
  DropDownHeaderArrow,
  DropDownListItem,
} from '../styles/dashboard';

class DashboardSelectMultiple extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedOption1: null,
      selectedOption2: null,
    };

    this.wrapperRef = null;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    const dummyCallback = () => {};

    if (this.props.setValueCallback1) {
      const onChange1 = this.props.onChange1 || dummyCallback;

      this.props.setValueCallback1(value => {
        this.onOptionClicked1(value, onChange1)();
      });
    }

    if (this.props.setValueCallback2) {
      const onChange2 = this.props.onChange2 || dummyCallback;

      this.props.setValueCallback2(value => {
        this.onOptionClicked2(value, onChange2)();
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  toggling = () => {
    const { isOpen } = this.state;

    this.setState({
      isOpen: !isOpen
    });
  };

  onOptionClicked1 = (value, callback) => () => {
    this.setState(
      {
        selectedOption1: value,
        isOpen: false
      },
      () => {
        if (callback) {
          callback(value);
        }
      }
    );
  };

  onOptionClicked2 = (value, callback) => () => {
    this.setState(
      {
        selectedOption2: value,
        isOpen: false
      },
      () => {
        if (callback) {
          callback(value);
        }
      }
    );
  };

  handleClickOutside = e => {
    const { isOpen } = this.state;

    if (isOpen && this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        isOpen: false
      });
    }
  };

  get title() {
    const { selectedOption1, selectedOption2 } = this.state;
    const { placeholder } = this.props;

    const result = [];
    if (selectedOption1) {
      result.push(selectedOption1);
    }

    if (selectedOption2) {
      result.push(selectedOption2);
    }

    return result.length > 0 ? result.join(' / ') : placeholder;
  }

  render() {
    const { isOpen, selectedOption1, selectedOption2 } = this.state;
    const { options1, options2 } = this.props;
    const DropDownHeaderComponent = this.props.DropDownHeader || DropDownHeader;
    const DropDownListContainerComponent =
      this.props.DropDownListContainer || DropDownListContainer;
    const DropDownListComponent = this.props.DropDownList || DropDownList;
    const dummyCallback = () => {};
    const onChange1 = this.props.onChange1 || dummyCallback;
    const onChange2 = this.props.onChange2 || dummyCallback;

    return (
      <DropDownContainer
        innerRef={wrapperRef => {
          this.wrapperRef = wrapperRef;
        }}
      >
        <DropDownHeaderComponent
          onClick={this.toggling}
          title={this.title}
        >
          {this.title}
          <DropDownHeaderArrow>
            <img src={ArrowIcon} alt="" />
          </DropDownHeaderArrow>
        </DropDownHeaderComponent>
        {isOpen && (
          <DropDownListContainerComponent>
            <DropDownListComponent>
              {options1.map((option, i) => (
                <DropDownListItem
                  key={`option1-${i}`}
                  onClick={this.onOptionClicked1(option, onChange1)}
                  isSelected={selectedOption1 === option ? true : false}
                >
                  {option}
                </DropDownListItem>
              ))}
              {options2.map((option, i) => (
                <DropDownListItem
                  key={`option2-${i}`}
                  onClick={this.onOptionClicked2(option, onChange2)}
                  isSelected={selectedOption2 === option ? true : false}
                >
                  {option}
                </DropDownListItem>
              ))}
            </DropDownListComponent>
          </DropDownListContainerComponent>
        )}
      </DropDownContainer>
    );
  }
}

export default DashboardSelectMultiple;



// WEBPACK FOOTER //
// ./src/instructor/components/dashboard-select-multiple.js